'use strict';

var _ = require('lodash');
var ChartFaresService = function ChartFaresService(commonFaresChartComponentsService, configurationService, momentService, classIndicesService, fcrService) {
  function getCurrentMonth() {
    return momentService.now(momentService.FIELD.FARES_USAGE_DATE).month();
  }
  function getCurrentYear() {
    return momentService.now(momentService.FIELD.FARES_USAGE_DATE).year();
  }
  function createDataCombinedWithLegend(orginalData, legend) {
    var data = _.cloneDeep(orginalData);
    _.forEach(legend, function (legend, i) {
      if (!legend.selected) {
        data[i] = 0;
      }
    });
    return data;
  }
  function setNoUsageBar(d) {
    d.isGap = true;
    d.cssClass = 'not-usage';
    d.patternId = 'gap-solid';
    d.tooltipLabel = 'No Usage';
    d.data = [];
    d.stripesData = [];
  }
  function isThereAnyDataToDisplay(data) {
    var sum = _.reduce(data, function (accumulator, element) {
      return accumulator + element;
    }, 0);
    return !!sum;
  }
  function transformItem(item, legend, currentMonth) {
    item.stackLabel = item.clazz;
    var dataPreparedToDisplay = [];
    var barsCss = [];
    var dataCombinedWithLegend = createDataCombinedWithLegend(item.data, legend);

    //arrange data in appropriate order
    //Previous month must be on top
    //We starts with current month eventually it will be on the bottom
    for (var i = 0; i < 12; i++) {
      var index = (currentMonth + i) % 12;
      dataPreparedToDisplay.push(dataCombinedWithLegend[index]);
      barsCss.push(legend[index].barCss);
    }
    if (!isThereAnyDataToDisplay(dataPreparedToDisplay)) {
      //insert no-usage bar
      setNoUsageBar(item);
    } else {
      //store prepare data
      item.stripesData = dataPreparedToDisplay;
      item.css = barsCss;
    }
  }
  function getMarketTagKey(market, legend) {
    var selectedLegendElements = getSelectedLegendElements(legend);
    if (selectedLegendElements.length !== 0) {
      var chartDateRange = calculateChartDateRange(selectedLegendElements);
      return fcrService.getFcrTagForMultipleEntitiesWithMarket(market, chartDateRange);
    }
    return '';
  }
  function createDataForChart(orginalData, legend, fcrTag) {
    var classesIndices = classIndicesService.prepareClassIndices(fcrTag);
    var currentMonth = getCurrentMonth();
    var data = _.cloneDeep(orginalData);
    return _.chain(data).sortBy(function (element) {
      return classesIndices[element.clazz];
    }).forEach(function (item) {
      transformItem(item, legend, currentMonth);
    }).value();
  }
  function adaptDataToChart(orginalData) {
    var data = _.cloneDeep(orginalData);
    _.forEach(data, function (d) {
      if (d.isGap) {
        return;
      }

      //prepare data for displaying in bar chart
      var lastNotNullVal, prevVal;
      for (var j = 1; j < d.stripesData.length; j++) {
        prevVal = d.stripesData[j - 1];
        if (prevVal !== 0) {
          lastNotNullVal = prevVal;
        }
        if (d.stripesData[j] !== 0 && lastNotNullVal) {
          d.stripesData[j] += lastNotNullVal;
        }
      }

      //revert data, because smaller bar must be render on bigger
      d.stripesData.reverse();
      d.css.reverse();
    });
    return data;
  }
  function getSelectedData(data, ranges) {
    var selectedData = [];
    _.forEach(ranges, function (range) {
      var indexes = _.range(range[0], range[1]);
      _.forEach(indexes, function (i) {
        selectedData.push(data[i].clazz);
      });
    });
    return selectedData;
  }
  function sortLegend(legend) {
    var result = [];
    var currentYear = getCurrentYear();
    var previousYear = currentYear - 1;
    var currentMonthIdx = getCurrentMonth();
    for (var i = 0; i < 12; i++) {
      var idx = (currentMonthIdx + i) % 12;
      if ((currentMonthIdx + i) / 12 < 1) {
        legend[idx].year = previousYear - 2000;
      } else {
        legend[idx].year = currentYear - 2000;
      }
      result.push(legend[idx]);
    }
    return result;
  }
  function getSelectedLegend(legend) {
    return _.transform(legend, function (result, element, id) {
      if (element.selected) {
        result.push(id + 1);
      }
      return result;
    });
  }
  function getSelectedLegendElements(legend) {
    return _.filter(legend, function (element) {
      return element.selected;
    });
  }
  function calculateChartDateRange(data) {
    var selectedMonths = _.chain(data).map(function (item) {
      return _.pick(item, ['monthId', 'year']);
    }).uniqWith(_.isEqual).sortBy(['year', 'monthId']).value();
    return [momentService.of(new Date('20' + selectedMonths[0].year, selectedMonths[0].monthId), momentService.FIELD.FARES_USAGE_DATE), momentService.of(new Date('20' + selectedMonths[selectedMonths.length - 1].year, selectedMonths[selectedMonths.length - 1].monthId), momentService.FIELD.FARES_USAGE_DATE).endOf('month').add(-1, 'second')];
  }
  function getLegendTitle(currentYear) {
    var legend = commonFaresChartComponentsService.getInitialLegend();
    var sortedLegend = sortLegend(legend);
    var firstLegendElement = sortedLegend[0];
    var lastLegendElement = sortedLegend[sortedLegend.length - 1];
    var thisYear = currentYear;
    var prevYear = thisYear - 1;
    return firstLegendElement.label + ' ' + prevYear + ' - ' + lastLegendElement.label + ' ' + thisYear;
  }
  function getMarkets(groupedByMarket) {
    return _.keys(groupedByMarket).sort();
  }
  function parseChartDataForTooltip(dataForSelectedMarket, d, legend) {
    var sortedMonths = sortLegend(legend).reverse();
    var dataForOneMarket = _.find(dataForSelectedMarket, function (obj) {
      return obj.clazz === d.clazz;
    });
    return _.chain(sortedMonths).filter({
      selected: true
    }).map(function (monthElement) {
      var value = dataForOneMarket.data[monthElement.monthId];
      return {
        value: value,
        month: monthElement.label,
        selected: monthElement.selected
      };
    }).value();
  }
  return {
    getSelectedData: getSelectedData,
    adaptDataToChart: adaptDataToChart,
    getCurrentMonth: getCurrentMonth,
    getCurrentYear: getCurrentYear,
    createDataForChart: createDataForChart,
    sortLegend: sortLegend,
    getLegendTitle: getLegendTitle,
    getSelectedLegend: getSelectedLegend,
    getMarkets: getMarkets,
    parseChartDataForTooltip: parseChartDataForTooltip,
    getMarketTagKey: getMarketTagKey
  };
};
ChartFaresService.$inject = ['CommonFaresChartComponentsService', 'ConfigurationService', 'MomentService', 'ClassIndicesService', 'FcrService'];
module.exports = ChartFaresService;